import React, { useState } from 'react';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';

export function isUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch {
    return false;
  }
}

interface UrlEvidenceValueProps {
  value: string;
  label: string;
}

export default function UrlEvidenceValue({ value, label }: UrlEvidenceValueProps) {
  const [imageError, setImageError] = useState(false);

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-block',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden',
      }}
    >
      {!imageError ? (
        <Box
          component="img"
          src={value}
          alt={label}
          onError={() => setImageError(true)}
          sx={{
            display: 'block',
            maxWidth: '100%',
            maxHeight: 320,
            objectFit: 'contain',
            bgcolor: 'grey.50',
          }}
        />
      ) : (
        <Box sx={{ p: 1.5 }}>
          <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', mb: 0.5 }}>
            Unable to display as image
          </Typography>
          <Typography
            component="a"
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            sx={{ wordBreak: 'break-all' }}
          >
            {value}
          </Typography>
        </Box>
      )}
      <Tooltip title="Open in new tab">
        <IconButton
          size="small"
          component="a"
          href={value}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            position: 'absolute',
            top: 4,
            right: 4,
            bgcolor: 'background.paper',
            '&:hover': { bgcolor: 'background.paper' },
            boxShadow: 1,
          }}
        >
          <OpenInNewIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
